"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringValuesEditor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _options = require("../../shared/enums/options");

var _propTypes2 = require("../../shared/propTypes");

var _addForm = _interopRequireDefault(require("../../shared/addForm"));

var _StringValuePill = require("./StringValuePill");

var _StringValuesSelector = require("./StringValuesSelector");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var StringValuesEditor = function StringValuesEditor(_ref) {
  var values = _ref.values,
      attribute = _ref.attribute,
      onValuesChanged = _ref.onValuesChanged;

  var onValueRemoved = function onValueRemoved(value) {
    var updatedValues = values.filter(function (selectedValue) {
      return selectedValue.value !== value.value;
    });
    onValuesChanged(updatedValues);
  };

  var onValueChanged = function onValueChanged(originalValue, updatedValue) {
    var updatedValues = _toConsumableArray(values);

    var orignalIndex = updatedValues.findIndex(function (searchValue) {
      return searchValue.value === originalValue.value;
    });

    if (orignalIndex >= 0) {
      updatedValues.splice(orignalIndex, 1, updatedValue);
      onValuesChanged(updatedValues);
    }
  };

  var onAdd = function onAdd(newValue) {
    var valuesClone = (0, _cloneDeep["default"])(values);
    valuesClone.push({
      type: _options.VALUE,
      value: newValue
    });
    onValuesChanged(valuesClone);
  };

  var onMultiAdd = function onMultiAdd(newValues) {
    var uniqueNewValues = validateNewValues(newValues);
    var valuesClone = (0, _cloneDeep["default"])(values);
    valuesClone = valuesClone.concat(uniqueNewValues.map(function (newValue) {
      if (validateValue(newValue) === null) {
        return {
          type: _options.VALUE,
          value: newValue
        };
      } else {
        return undefined;
      }
    }));
    onValuesChanged(valuesClone.filter(function (x) {
      return x !== undefined;
    }));
  };

  var validateNewValues = function validateNewValues(newValues) {
    return newValues.reduce(function (uniqueNewValues, newValue) {
      if (uniqueNewValues.every(function (value) {
        return value.toLowerCase() !== newValue.toLowerCase();
      })) uniqueNewValues.push(newValue);
      return uniqueNewValues;
    }, []);
  };

  var validateValue = function validateValue(newValue) {
    var returnValue = null;
    values.forEach(function (value) {
      if (value.value.toLowerCase() === newValue.toLowerCase()) {
        returnValue = "Value [".concat(newValue, "] is not unique");
      }
    });
    return returnValue;
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null, attribute ?
    /*#__PURE__*/
    _react["default"].createElement(_StringValuesSelector.StringValuesSelector, {
      selectedValues: values,
      availableValues: attribute ? attribute.values : null,
      onSelectedValuesChanged: onValuesChanged,
      "data-testid": "StringValuesSelector"
    }) :
    /*#__PURE__*/
    _react["default"].createElement(_addForm["default"], {
      onAdd: onAdd,
      validateOption: validateValue,
      "data-testid": "AddForm",
      onMultiAdd: onMultiAdd
    }), values.map(function (value) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_StringValuePill.StringValuePill, {
          key: value.value,
          value: value,
          values: attribute ? attribute.values : values,
          canEdit: !Boolean(attribute),
          onValueRemoved: onValueRemoved,
          onValueChanged: onValueChanged,
          "data-testid": "StringValuePill"
        })
      );
    }))
  );
};

exports.StringValuesEditor = StringValuesEditor;
StringValuesEditor.propTypes = {
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.valueShape)),
  attribute: _propTypes["default"].shape(_propTypes2.atttributeShape),
  onValuesChanged: _propTypes["default"].func.isRequired
};
StringValuesEditor.defaultProps = {
  values: []
};